import dayjs from 'dayjs';
import { TeamInfo, UserInfo } from '@/types';
import { PersonalSurveyProfile } from '@/types/personalSurveyProfile';

export const PROJECT_UUID = 'proj-666151c3-c2d0-4ad7-ad41-4bb2d71a155a';

export const setupTechTouch = (
  userInfo: UserInfo,
  teamInfo: TeamInfo,
  personalSurveyProfile?: PersonalSurveyProfile,
): void => {
  const techTouchId = import.meta.env.VITE_TECH_TOUCH_ID;
  if (!techTouchId) return;

  // 二重にスクリプトを読み込まない
  const existingScript = document.getElementById('techtouch-integration');
  if (existingScript) return;

  const techTouchCode = document.createElement('script');
  techTouchCode.setAttribute('id', 'techtouch-integration');
  techTouchCode.setAttribute('type', 'text/javascript');

  const enablePersonalHint = teamInfo.enable_personal_survey_mail;
  techTouchCode.textContent = `
      !function () {
        window.TechtouchObject = {
          startTechtouch: function() {
            // iframe内で動作させる場合は以下の1行を削除もしくはコメントアウトしてください
            try { if (window.top !== window.self) return; } catch(e) { return; }
            if ('TechtouchObject' in window && document.querySelector('script#techtouch-snippet')) return;
            if ('TechtouchAddon' in window) return;
            window.TechtouchObject = {
              organizationUuid: "${techTouchId}"
            };
            var e = document.createElement("script"); e.async = 1, e.src = "https://apps.techtouch.jp/script/${techTouchId}/main.js?projectUuid=${PROJECT_UUID}"; e.id = "techtouch-snippet";
            var t = document.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(e, t);
          }
        };

        window.TechtouchAdmin={customProperty:{_data:{},get:function(t){return this._data[t]},set:function(t,e){this._data[t]=e},delete:function(t){delete this._data[t]},keys:function(){return Object.keys(this._data)}}};
        // ラベル「ユーザーID」に対応
        TechtouchAdmin.customProperty.set("f1b034bd-59f9-49d2-b920-e70c6206b4ec", "${userInfo.id}")
        // ラベル「チームID」に対応
        TechtouchAdmin.customProperty.set("da39bf21-7ddd-41eb-8fb0-4b82600ce40a", "${userInfo.team_id}")
        // ラベル「契約ID」に対応
        TechtouchAdmin.customProperty.set("0c892e30-b832-4a40-afb6-58bc3bcb50dd", "${userInfo.product_contract_id}")
        // ラベル「ユーザーロール」に対応
        TechtouchAdmin.customProperty.set("94c3e514-5aec-4fe4-9fcf-b95373f38325", "${userInfo.role}")
        // ラベル「パーソナルニュース」に対応
        TechtouchAdmin.customProperty.set("e6b9b189-87a0-48ba-a03e-98e4b002a63e", "${userInfo.has_personal_news}")
        // ラベル「組織タグ」に対応
        TechtouchAdmin.customProperty.set("878ebb13-f368-46bd-9b05-dd618f65a3fd", "${userInfo.organization_tag_ids.join(',')}")
        // ラベル「ユーザー作成日」に対応
        TechtouchAdmin.customProperty.set("c943e4f5-d887-4dd4-b326-a4cf35e77832", "${dayjs(userInfo.created_at).format('YYYY-MM-DD')}")
        // ラベル「チーム作成日」に対応
        TechtouchAdmin.customProperty.set("56ce69b7-48ae-45bf-9209-0a21ae3a883f", "${dayjs(teamInfo.created_at).format('YYYY-MM-DD')}")
        // ラベル「契約作成日」に対応
        TechtouchAdmin.customProperty.set("ccbc06a6-a473-4745-bb4e-3075789d8ed9", "${dayjs(userInfo.contract_created_at).format('YYYY-MM-DD')}")${
          enablePersonalHint
            ? `
        // ラベル「所属部門の入力有無」に対応
        TechtouchAdmin.customProperty.set("1c2f45c2-3ec5-4b53-a1e4-a23031d99cf2", "${!!personalSurveyProfile?.department}")
        // ラベル「市場領域の入力有無」に対応
        TechtouchAdmin.customProperty.set("422c5d72-4d58-4efb-b672-22bf6a26af71", "${!!personalSurveyProfile?.market_area}")
        // ラベル「技術領域の入力有無」に対応
        TechtouchAdmin.customProperty.set("5f0082fb-9e9f-4643-a6c9-631a491eb6de", "${!!personalSurveyProfile?.technology_area}")
        // ラベル「技術課題の入力有無」に対応
        TechtouchAdmin.customProperty.set("518617fe-25b6-4fc2-9b80-4719a2e1aaff", "${!!personalSurveyProfile?.technical_challenge}")`
            : ''
        }
        // ラベル「チームステータス」に対応
        TechtouchAdmin.customProperty.set("cd3100d4-a19e-4142-bc73-b7495b5c5c86", "${teamInfo.status}")
        // ラベル「契約ステータス」に対応
        TechtouchAdmin.customProperty.set("fd02959f-75d3-4f74-a688-e3eec6d77a42", "${userInfo.contract_status}")

        window.TechtouchObject.startTechtouch();
      }()
    `;
  document.head.appendChild(techTouchCode);
};
